import React, { useState, useEffect } from 'react'
import './navbar.css'
import SearchIcon from '@mui/icons-material/Search';
import Badge from '@mui/material/Badge';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { NavLink, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../helper';
import { useCart } from '../contextreducer/ContextReducer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Avatar from '@mui/material/Avatar';


export default function Navbar() {

    const data = useCart()

    const navigate = useNavigate()

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleDropdownOpen = () => {
        setIsDropdownOpen(true);
    };

    const handleDropdownClose = () => {
        setTimeout(() => {
            setIsDropdownOpen(false);
        }, 2000); // 4 seconds delay
    };

    const useremail = localStorage.getItem("userEmail");

    const [username, setUsername] = useState([]);

    useEffect(() => {
        const fetchUsername = async () => {
            try {
                const response = await fetch(`${BASE_URL}/api/user`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ email: useremail })
                });

                if (response.ok) {
                    const data = await response.json();
                    // console.log(data);
                    setUsername(data);
                }

            } catch (error) {
                console.log('Error:', error);
            }
        };

        fetchUsername();
    }, [useremail]);

    const handlelogout = () => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userEmail");
        navigate("/login")
    }

    const buynowpage = () => {
        navigate("/buynow")
    }

    return (
        <header>
            <nav>
                <div className="left">
                <div className="sidebar-toggle" onClick={toggleSidebar}>
                <MenuIcon/>
                    </div>
                    <div className="navlogo">
                        <NavLink to='/'><img src="./amazon_logo.png" alt="" /></NavLink>
                    </div>
                    <div className="nav_searchbaar">
                        <input type="text" name='' id='' placeholder='Search' />
                        <div className="search_icon">
                            <SearchIcon id='search' />
                        </div>
                    </div>
                </div>
                <div className="right">
                    {(localStorage.getItem("authToken"))
                        ? <div className="right">
                            <div className="nav_btn">
                                <li className="nav-item dropdown nav-dropdown" onMouseEnter={handleDropdownOpen} onMouseLeave={handleDropdownClose}>
                                    <NavLink
                                        className="nav-link dropdown-toggle"
                                        to="#"
                                        id="navbarDropdown"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded={isDropdownOpen}
                                    >
                                        Hello, {username.name}
                                    </NavLink>
                                    <ul className={`dropdown-menu drop-menu ${isDropdownOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
                                        <li>
                                            <button className="dropdown-item logout-btn" onClick={handlelogout}>
                                                Logout
                                            </button>
                                        </li>
                                    </ul>
                                </li>
                            </div>
                        </div> :
                        <div className="nav_btn">
                            <NavLink to="/login">Signin</NavLink>
                        </div>
                    }
                    <li className="nav_btn">
                        <NavLink to="/order">Orders</NavLink>
                    </li>
                    <div className="cart_btn" onClick={buynowpage}>
                        <Badge badgeContent={data.length} color="primary" showZero>
                            <ShoppingCartIcon id='icon' />
                        </Badge>
                        <p>Cart</p>
                    </div>
                </div>
            </nav>
            {/* mobile responsive */}
            <div className={`sidebar sidebar_close ${isSidebarOpen ? 'open' : ''}`}>
            {(localStorage.getItem("authToken"))
                        ? 
                                <div className='avtar_heading'>
                                <Avatar className='avtar'></Avatar>
                                <li className="nav-item dropdown nav-dropdown" onMouseEnter={handleDropdownOpen} onMouseLeave={handleDropdownClose}>
                                    <li
                                        className="dropdown-toggle"
                                        id="navbarDropdown"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded={isDropdownOpen}
                                    >
                                        Hello, {username.name}
                                    </li>
                                    <ul className={`dropdown-menu drop-menu ${isDropdownOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
                                        <li>
                                            <button className="dropdown-item logout-btn" onClick={handlelogout}>
                                                Logout
                                            </button>
                                        </li>
                                    </ul>
                                </li>
                                <CloseIcon onClick={toggleSidebar}/> 
                            </div> 
                                :
              
                        <li className="nav_btn avtar_heading">
                            <NavLink to="/login">Signin</NavLink>
                            <CloseIcon className='close' onClick={toggleSidebar}/>  
                        </li>
                        
                    }
                    <li className="nav_btn">
                        <NavLink to="/order">Orders</NavLink>
                    </li>
    </div>
        </header>
    )
}
